import { Component } from '@angular/core';

@Component({
  selector: 'app-cree-retour-frns',
  templateUrl: './cree-retour-frns.component.html',
  styleUrls: ['./cree-retour-frns.component.scss'],
})
export class CreeRetourFrnsComponent {}
